/* eslint-disable react/no-array-index-key */

import { Box, Text, DynamicGrid } from '@primerai/thread';
import { useSelector } from 'react-redux';
import { appSwitcherMenuConfig } from './AppSwitcherConfig';
import AppSwitcherMenuOption from './AppSwitcherMenuOption';
import {
  menuFilter,
  batchByGroup,
  EMPTY_BATCH,
  BatchElementType,
  sortByGroup,
} from './helpers';
import { ProductGrid } from './styles';
import { AppSwitcherConfig } from './types';
import { getEnabledFeatureFlags } from '~/store/auth/selectors';

const NoProducts = () => (
  <Box>
    <Text>No Products Found. Contact your account manager for access.</Text>
  </Box>
);

const AppSwitcherMenu = () => {
  const featureFlags = useSelector(getEnabledFeatureFlags);
  const filteredOptions = appSwitcherMenuConfig
    .filter(menuFilter(featureFlags))
    .sort(sortByGroup);

  const batchedOptions = filteredOptions.reduce(batchByGroup, EMPTY_BATCH);

  const cleanBatches = batchedOptions.filter((batch: BatchElementType) =>
    Array.isArray(batch),
  ) as AppSwitcherConfig[][];

  if (cleanBatches.length === 0) {
    return <NoProducts />;
  }
  return (
    <Box>
      <Text as="p">Select an application to get started</Text>
      <ProductGrid>
        {cleanBatches.map((batch: AppSwitcherConfig[], batchIndex: number) => (
          <DynamicGrid
            gap="$5"
            itemWidth={batchIndex === 0 ? 300 : 150}
            key={batchIndex}
            mb="$5"
            pb="$5"
          >
            {batch.map(config => (
              <AppSwitcherMenuOption config={config} key={config.id} />
            ))}
          </DynamicGrid>
        ))}
      </ProductGrid>
    </Box>
  );
};

export default AppSwitcherMenu;
